<template>
  <div>
    detail
  </div>
</template>

<script setup>

</script>

<style scoped src="./index.css"></style>
